/* This file was generated automatically. Do not edit manually. */

export enum AccountNoteCustomerClassifications {
    General = 'General',
    FoodAndBeverage = 'FoodAndBeverage',
    FrontOffice = 'FrontOffice',
    Reservations = 'Reservations',
    Housekeeping = 'Housekeeping',
    Maintenance = 'Maintenance',
    PreviousStay = 'PreviousStay',
    FamilyRelations = 'FamilyRelations',
    Gifts = 'Gifts',
    Accounting = 'Accounting',
    Complaints = 'Complaints',
    Other = 'Other',
}
